<div class="mx-2 my-4 mx-lg-4 card">

  <p-table #dt [columns]="cols"
    styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
    [value]="listaResultado" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
    [(selection)]="object" [first]="first">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.nomeFantasia"
          (tableOrderChange)="changeOrder()" class="text-center">Unidade Cliente</th>
        <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.nomeFantasiaUnidadeAuditora"
          (tableOrderChange)="changeOrder()" class="text-center">Auditor(a)</th>
        <th style="width:7%; text-align: center;" >Ações</th>
      </tr>
      <tr>
        <th><input [formControl]="pesquisa.controls.nomeFantasia" type="text"
            class="form-control text-uppercase"></th>
        <th><input [formControl]="pesquisa.controls.nomeFantasiaUnidadeAuditora" type="text"
            class="form-control text-uppercase"></th>
        <th></th>
      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="rowData">
        <td>{{rowData.nomeFantasia}}</td>
        <td>{{rowData.nomeFantasiaUnidadeAuditora}}</td>
        <td>
          <div class="d-flex align-items-center justify-content-center">
            <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
              <button class="btn btn-sm btn-icon btn-danger" (click)="removerAssociacaoAuditoria(rowData)">
                <i class="mdi mdi-delete"></i>
              </button>
            </span>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-columns>
      <div class="card-footer bg-white row justify-content-between minPage222 ">

        <div class="pb-2 pb-sm-0">
          <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total"
            [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
          </ngb-pagination>
        </div>
        <div class="pb-2 pb-sm-0">
          <div class="btn-group" role="group">
            <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
              <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom">
              </button>
            </span>
            <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}"
              type="button" class="btn btn-outline-primary">10</button>
            <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}"
              type="button" class="btn btn-outline-primary">25</button>
            <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}"
              type="button" class="btn btn-outline-primary">50</button>
            <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}"
              type="button" class="btn btn-outline-primary">100</button>
          </div>
        </div>

      </div>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1">
          Nenhum registro foi encontrado
        </td>
      </tr>
    </ng-template>

  </p-table>

</div>